import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getDataSertifikasiRpl = 'sertifikasi-rpl';
const getDetailDataSertifikasiRpl = 'sertifikasi-rpl/';
const postDataSertifikasiRpl = 'sertifikasi-rpl';
const putDataSertifikasiRpl = 'sertifikasi-rpl/';
const deleteDataSertifikasiRpl = 'sertifikasi-rpl/delete-sertifikasi-rpl/'
const deleteDokumenSertifikasiRpl = 'sertifikasi-rpl/delete-dokumen-sertifikasi-rpl/'
const deleteDokumenPenerbitanRpl = 'sertifikasi-rpl/delete-dokumen-penerbitan-sertifikasi-rpl/';
const deleteSertifikasiRplMataUji = 'sertifikasi-rpl/delete-sertifikasi-rpl-mata-uji/';
const deleteJadwalRpl = 'sertifikasi-rpl/delete-jadwal-sertifikasi-rpl/';
const getKategoriRpl = 'sertifikasi-rpl/kategori-sertifikasi-rpl';

const exportRpl = 'sertifikasi-rpl-export';

class MasterRplService {

    getDataSertifikasiRpl(pageNo, pageSize, filter, idLevel) {
        return axios.get(
            API_URL + getDataSertifikasiRpl, {
                params: {
                    pageNo,
                    pageSize,
                    filter,
                    idLevel
                },
                headers: authHeader()
            }  
        );        
    }

    getKategoriRpl() {
        return axios.get(API_URL + getKategoriRpl, {
            headers: authHeader()
        });
    }

    getDetailDataSertifikasiRpl(id_sertifikasi_rpl) {
        return axios.get(API_URL + getDetailDataSertifikasiRpl + id_sertifikasi_rpl, {
            headers: authHeader()
        });
    }

    postDataSertifikasiRpl(request) {
        try {
            let formJadwalRplRequest = [];        
            if(request.jadwalRplRequest && request.jadwalRplRequest.length > 0) {
                for(let i = 0; i < request.jadwalRplRequest.length; i++) {
                    let jadwal = { 
                        "tanggal": request.jadwalRplRequest[i].tanggal, 
                        "waktuDimulai": request.jadwalRplRequest[i].waktuDimulai,
                        "waktuBerakhir": request.jadwalRplRequest[i].waktuBerakhir
                    };            
                    formJadwalRplRequest.push(jadwal);
                }  
            }

            let formSertifikasiRplMataUjiRequest = [];
            if(request.sertifikasiRplMataUjiRequest && request.sertifikasiRplMataUjiRequest.length > 0) {
                for(let i = 0; i < request.sertifikasiRplMataUjiRequest.length; i++) {
                    let idMasterMataUji = request.sertifikasiRplMataUjiRequest[i].idMasterMataUji;
                    if(idMasterMataUji !== "") {
                        let mataUji = {
                            "idMasterMataUji": idMasterMataUji
                        };
                        formSertifikasiRplMataUjiRequest.push(mataUji);
                    }
                }
            }

            let formSertifikasiRplMataUjiRequestTc = [];
            if(request.sertifikasiRplMataUjiRequestTc && request.sertifikasiRplMataUjiRequestTc.length > 0) {
                for(let i = 0; i < request.sertifikasiRplMataUjiRequestTc.length; i++) {
                    let idMasterMataUji = request.sertifikasiRplMataUjiRequestTc[i].idMasterMataUji;
                    let biayaMataUji = request.sertifikasiRplMataUjiRequestTc[i].biayaMataUji;
                    if(idMasterMataUji !== "") {
                        let mataUjiTc = {
                            "idMasterMataUji": idMasterMataUji,
                            "biayaMataUji" : biayaMataUji 
                        };
                        formSertifikasiRplMataUjiRequestTc.push(mataUjiTc);
                    }
                }
            }

            let formDokumenPendukungSertifikasiRplRequest = [];
            if(request.dokumenPendukungSertifikasiRplRequest && request.dokumenPendukungSertifikasiRplRequest.length > 0) {
                for (let i = 0; i < request.dokumenPendukungSertifikasiRplRequest.length; i++) {
                    const element = request.dokumenPendukungSertifikasiRplRequest[i];                
                    let dokumen = {                        
                        "idMasterDokumenPendukung": element.idMasterDokumenPendukung,
                        "statusRequired": element.statusRequired
                    };
                    formDokumenPendukungSertifikasiRplRequest.push(dokumen);
                }
            }        

            let formDokumenPersyaratanSertifikat = []
            if(request.dokumenPersyaratanSertifikat && request.dokumenPersyaratanSertifikat.length > 0) {
                for (let i = 0; i < request.dokumenPersyaratanSertifikat.length; i++) {
                    const element = request.dokumenPersyaratanSertifikat[i];          
                    let dokumenSertifikat = {
                        "idMasterDokumen": element.idMasterDokumen,
                        "statusRequired": element.statusRequired
                    }      
                    formDokumenPersyaratanSertifikat.push(dokumenSertifikat);
                }
            }

            let form = {
                flyer : request.flyer,
                namaRpl: request.namaRpl,
                idLevel: request.idLevel,
                sertifikasiRplMataUjiRequest: formSertifikasiRplMataUjiRequest,
                biaya: request.biaya,
                biayaMengulang: request.biayaMengulang,
                jenisBiayaMengulang: request.jenisBiayaMengulang,
                jadwalRplRequest: formJadwalRplRequest,
                kapasitas: request.kapasitas,
                jenisWorkshop: request.jenisWorkshop,
                lokasi: request.lokasi,
                linkWorkshop: request.linkWorkshop,
                sertifikasiRplMataUjiRequestTc: formSertifikasiRplMataUjiRequestTc,
                biayaTc: request.biayaTc,
                biayaPerMataUji: request.biayaPerMataUji,
                dokumenPendukungSertifikasiRplRequest: formDokumenPendukungSertifikasiRplRequest,
                dokumenPersyaratanSertifikat: formDokumenPersyaratanSertifikat,
                status: request.status
            }             

            if(form.sertifikasiRplMataUjiRequest.length == 0) {
                delete form.sertifikasiRplMataUjiRequest;
            }

            if(form.sertifikasiRplMataUjiRequestTc.length == 0) {
                delete form.sertifikasiRplMataUjiRequestTc
            }

            return axios.post(API_URL + postDataSertifikasiRpl, form, {
                headers: authHeader()
            });
        } catch (error) {
            // comment console console.log(error)
        }
    }

    putDataSertifikasiRpl(request) {
        try {
            let formJadwalRplRequest = [];        
            if(request.jadwalRpl && request.jadwalRpl.length > 0) {
                for(let i = 0; i < request.jadwalRpl.length; i++) {
                    let jadwal = { 
                        "idJadwalRpl": request.jadwalRpl[i].idJadwalRpl,
                        "tanggal": request.jadwalRpl[i].tanggal, 
                        "waktuDimulai": request.jadwalRpl[i].waktuDimulai,
                        "waktuBerakhir": request.jadwalRpl[i].waktuBerakhir
                    };            
                    formJadwalRplRequest.push(jadwal);
                }  
            }

            let formSertifikasiRplMataUjiRequest = [];
            if(request.sertifikasiRplMataUjiRequest && request.sertifikasiRplMataUjiRequest.length > 0) {
                for(let i = 0; i < request.sertifikasiRplMataUjiRequest.length; i++) {
                    let element = request.sertifikasiRplMataUjiRequest[i];
                    let mataUji = {
                        "idMasterMataUji": element.idMasterMataUji,
                        "idSertifikasiRplMataUji": element.idSertifikasiRplMataUji ? element.idSertifikasiRplMataUji : ""
                    };
                    formSertifikasiRplMataUjiRequest.push(mataUji);
                }
            }

            let formSertifikasiRplMataUjiRequestTc = [];
            if(request.sertifikasiRplMataUjiRequestTc && request.sertifikasiRplMataUjiRequestTc.length > 0) {
                for(let i = 0; i < request.sertifikasiRplMataUjiRequestTc.length; i++) {
                    let element = request.sertifikasiRplMataUjiRequestTc[i];
                    let biayaMataUji = request.sertifikasiRplMataUjiRequestTc[i].biayaMataUji;

                    let mataUjiTc = {
                        "idMasterMataUji": element.idMasterMataUji,
                        "biayaMataUji" : biayaMataUji,
                        "idSertifikasiRplMataUji": element.idSertifikasiRplMataUji ? element.idSertifikasiRplMataUji : ""
                    };
                    formSertifikasiRplMataUjiRequestTc.push(mataUjiTc);
                }
            }

            let formDokumenPendukungSertifikasiRplRequest = [];
            if(request.dokumenPendukungSertifikasiRpl && request.dokumenPendukungSertifikasiRpl.length > 0) {
                for (let i = 0; i < request.dokumenPendukungSertifikasiRpl.length; i++) {
                    const element = request.dokumenPendukungSertifikasiRpl[i];                
                    let dokumen = {
                        "idMasterDokumenPendukung": element.idMasterDokumenPendukung,
                        "idDokumenPendukungSertifikasiRpl": element.idDokumenPendukungSertifikasiRpl,
                        "statusRequired": element.statusRequired
                    };
                    formDokumenPendukungSertifikasiRplRequest.push(dokumen);
                }
            }        

            let formDokumenPersyaratanSertifikat = []
            if(request.dokumenPersyaratanSertifikat && request.dokumenPersyaratanSertifikat.length > 0) {
                for (let i = 0; i < request.dokumenPersyaratanSertifikat.length; i++) {
                    const element = request.dokumenPersyaratanSertifikat[i];          
                    let dokumenSertifikat = {
                        "idMasterDokumen": element.idMasterDokumen,
                        "idDokumenPendukung": element.idDokumenPendukung,
                        "statusRequired": element.statusRequired
                    }      
                    formDokumenPersyaratanSertifikat.push(dokumenSertifikat);
                }
            }                       

            let formDeleteMataUji = [];
            if(request.deleteMataUji && request.deleteMataUji.length > 0) {
                for (let i = 0; i < request.deleteMataUji.length; i++) {
                    const element = request.deleteMataUji[i];          
                    let mataUji = {
                        "idMataUjiRpl": element.idMataUjiRpl,                        
                    }      
                    formDeleteMataUji.push(mataUji);
                }
            }    
            
            let formDeleteJadwal = [];
            if(request.deleteJadwal && request.deleteJadwal.length > 0) {
                for (let i = 0; i < request.deleteJadwal.length; i++) {
                    const element = request.deleteJadwal[i];
                    let jadwal = {
                        "idJadwalRpl": element.idJadwalRpl
                    }
                    formDeleteJadwal.push(jadwal);
                }
            }

            let formDeleteDokumenPenerbit = [];
            if(request.deleteDokumenPenerbitan && request.deleteDokumenPenerbitan.length > 0) {
                for (let i = 0; i < request.deleteDokumenPenerbitan.length; i++) {
                    const element = request.deleteDokumenPenerbitan[i];
                    let dokumen = {
                        "idDokumenPendukung": element.idDokumenPendukung
                    }
                    formDeleteDokumenPenerbit.push(dokumen)
                }
            }

            let formDeleteDokumenPendukung = [];
            if(request.deleteDokumenPendukung && request.deleteDokumenPendukung.length > 0) {
                for (let i = 0; i < request.deleteDokumenPendukung.length; i++) {
                    const element = request.deleteDokumenPendukung[i];
                    let dokumen = {
                        "idDokumenPendukung": element.idDokumenPendukung
                    }
                    formDeleteDokumenPendukung.push(dokumen);
                }
            }

            let form = {
                flyer : request.flyer,
                namaRpl: request.namaRpl,
                idLevel: request.idLevel,
                sertifikasiRplMataUjiRequest: formSertifikasiRplMataUjiRequest,
                biaya: request.biaya,
                biayaMengulang: request.biayaMengulang,
                jenisBiayaMengulang: request.jenisBiayaMengulang,
                jadwalRplRequest: formJadwalRplRequest,
                kapasitas: request.kapasitas,
                jenisWorkshop: request.jenisWorkshop,
                lokasi: request.lokasi,
                linkWorkshop: request.linkWorkshop,
                sertifikasiRplMataUjiRequestTc: formSertifikasiRplMataUjiRequestTc,
                biayaTc: request.biayaTc,
                biayaPerMataUji: request.biayaPerMataUji,
                dokumenPendukungSertifikasiRplRequest: formDokumenPendukungSertifikasiRplRequest,
                dokumenPersyaratanSertifikat: formDokumenPersyaratanSertifikat,
                status: request.status,         
                deleteJadwal: formDeleteJadwal,       
                deleteMataUji: formDeleteMataUji,
                deleteDokumenPendukung: formDeleteDokumenPendukung,
                deleteDokumenPenerbitan: formDeleteDokumenPenerbit,
            } 

            if(form.deleteJadwal.length == 0) {
                delete form.deleteJadwal;
            }

            if(form.sertifikasiRplMataUjiRequest.length == 0) {
                delete form.sertifikasiRplMataUjiRequest;
            }

            if(form.sertifikasiRplMataUjiRequestTc.length == 0) {
                delete form.sertifikasiRplMataUjiRequestTc
            }

            if(form.deleteMataUji.length == 0) {
                delete form.deleteMataUji;
            }

            if(form.deleteDokumenPenerbitan.length == 0) {
                delete form.deleteDokumenPenerbitan;
            }

            if(form.deleteDokumenPendukung.length == 0) {
                delete form.deleteDokumenPendukung;
            }
            
            return axios.put(API_URL + putDataSertifikasiRpl + request.idSertifikasiRpl, form, {
                headers: authHeader()
            });
        } catch (error) {
            // comment console console.log(error)
        }
    }

    deleteDokumenSertifikasiRpl(id) {
        return axios.delete(API_URL + deleteDokumenSertifikasiRpl + id, {
            headers: authHeader()
        });
    }

    deleteDokumenPenerbitanRpl(id) {
        return axios.delete(API_URL + deleteDokumenPenerbitanRpl + id, {
            headers: authHeader()
        });
    }

    deleteSertifikasiRplMataUji(id) {
        return axios.delete(API_URL + deleteSertifikasiRplMataUji + id, {
            headers: authHeader()
        });
    }

    deleteDataSertifikasiRpl(id) {
        return axios.delete(API_URL + deleteDataSertifikasiRpl + id, {
            headers: authHeader()
        });
    }

    deleteJadwalRpl(id) {
        return axios.delete(API_URL + deleteJadwalRpl + id, {
            headers: authHeader()
        });
    }
    
    exportDataRpl(idLevel) {
        return axios.get(API_URL + exportRpl + '?idLevel=' + idLevel, {
            headers: authHeader(),
            responseType: 'blob',
        });
    }
    
}

export default new MasterRplService();